import { ViewEmployee as ViewEmployeeComponent } from "../../Components";

const ViewEmployee = () => {
  return <ViewEmployeeComponent />;
};

export default ViewEmployee;
